module.exports = __webpack_public_path__ + "img/en.268af7e7.svg";